const CHECKIN_KEYS = ['checkin', 'arrivalDate', 'arrivaldate']
const CHECKOUT_KEYS = ['checkout', 'departureDate', 'departuredate']

export function getQueryTripParams(query: Record<string, unknown>): Params {
  const checkin = tryParseDateParam(getAnyOf(query, CHECKIN_KEYS))
  const checkout = tryParseDateParam(getAnyOf(query, CHECKOUT_KEYS))
  const duration = tryParseInt(query.duration)

  if (!checkin || (!checkout && !duration))
    return { checkin: undefined, checkout: undefined, duration: undefined }

  const params: Params = {}
  params.checkin = toDate(checkin)
  params.checkout = checkout
    ? toDate(checkout)
    : toDate(calculateCheckoutDate(checkin, duration!))
  params.duration =
    duration && duration <= calculateDuration(checkin, params.checkout)
      ? duration
      : undefined

  return params
}
